import React, { FunctionComponent, MouseEventHandler, useEffect, useState } from 'react';
import landingStyles from './styles/landing.scss';
import logo from '../../assets/images/rtspro-logo-blue.svg';
import { Button } from 'shamrock-clover-ui';
import Login from '../login/Login';
import { useTranslation } from 'react-i18next';
import { EasterEggWrapper } from '../../utils/easterEgg';
import { setFeatures } from '../../redux/actions/appActions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'bootstrap';

const Config = require('Config');

interface LandingProps {
  handleShowAsSupportPage: MouseEventHandler;
  sendAnalyticsEvent: (arg: string) => void;
  setRerender: React.Dispatch<React.SetStateAction<number>>;
}

const Landing: FunctionComponent<LandingProps> = ({ handleShowAsSupportPage, sendAnalyticsEvent, setRerender }) => {
  const { t } = useTranslation();
  const features = useSelector<RootState, string[]>((state) => state.app.features);
  const cpua4769EasterEggWeb = features.includes('CPUA-4769-WEB-EASTER-EGG');

  const dispatch = useDispatch();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const triggerLoginModal = () => setShowLoginModal(!showLoginModal);
  const handleRedirectToLogin = () => {
    sendAnalyticsEvent('login');
    triggerLoginModal();
  };

  const handleRedirectToSignUp = () => {
    sendAnalyticsEvent('createAccount');
    window.location.href = `${Config.registerUrl}`;
  };

  const handleRedirectToCreditTrial: MouseEventHandler = (e) => {
    e.preventDefault();
    sendAnalyticsEvent('createAccount');
    window.location.href = `${Config.registerUrl}/trial-service`;
  };

  return (
    <React.Fragment>
      {showLoginModal && (
        <Login
          closeLogin={triggerLoginModal}
          sendAnalyticsEvent={sendAnalyticsEvent}
          setRerender={setRerender}
        />
      )}
      <div className={landingStyles.rtsProLogo}>
        <EasterEggWrapper
          featureToSet="CPUA-4769-WEB"
          features={features}
          actionCreator={setFeatures}
          dispatch={dispatch}
          isEasterEggEnabled={cpua4769EasterEggWeb}
        >
          <img src={logo} alt="rtspro_blue_logo" />
        </EasterEggWrapper>
      </div>
      <div className={landingStyles.welcome}>
        <EasterEggWrapper
          featureToSet="CPUA-5206"
          features={features}
          actionCreator={setFeatures}
          dispatch={dispatch}
          isEasterEggEnabled={cpua4769EasterEggWeb}
        >

          <div className={landingStyles.welcomeInner}>
            <h2 data-testid="welcome-header">{t('welcome')}!</h2>
            <p>{t('landing_subheading')}</p>
          </div>
        </EasterEggWrapper>
      </div>
      <div className={landingStyles.buttonContainer}>
        <div className={landingStyles.callToAction}>
          <Button
            buttonStyle="outlined"
            onClick={handleRedirectToSignUp}
            width="176px"
            height="44px"
            data-testid="create-account-button"
          >
            <span className={landingStyles.buttonText}>{t('create_acct')}</span>
          </Button>
        </div>
        <div className={landingStyles.callToAction}>
          <Button onClick={handleRedirectToLogin} width="176px" height="44px">
            <span className={landingStyles.buttonText} data-testid="log-in-button">
              {t('login')}
            </span>
          </Button>
        </div>
        <div className={landingStyles.callToActionLink}>
          <a href="#" onClick={handleRedirectToCreditTrial}>
            {t('credit_service')}
          </a>
        </div>
        <div className={landingStyles.questions}>
          <span>{t('questions')}</span>
          <a onClick={handleShowAsSupportPage} data-testid="contact-us-link">{t('contact_us')}</a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Landing;
